module.exports = __webpack_public_path__ + "static/media/ios-beer.0e9275f4.svg";